import React from 'react';
import { setCurrentView } from 'core/utils';
import { BillingQuickBooksViewStore } from '../stores';
import { BillingQuickBooksTemplate } from 'themes/modules/billing/pages';

@setCurrentView(rootStore => new BillingQuickBooksViewStore(rootStore), 'billingQuickBooksViewStore')
class BillingQuickBooks extends React.Component {
	render() {
		return <BillingQuickBooksTemplate {...this.props} viewStore={this.props.billingQuickBooksViewStore} />;
	}
}

export default BillingQuickBooks;
